<script>
	import { auth } from './firebase'
	import { onMount } from 'svelte'
	import { currentUserStore } from './stores'
	import Header from './Header.svelte'
	// Router
	import Router from 'svelte-spa-router'
	import Homepage from './Homepage.svelte'
	import AnswerForm from './AnswerForm.svelte'
	import EditForm from './EditForm.svelte'
	import ViewFormResults from './ViewFormResults.svelte'
import PresentResults from './PresentResults.svelte'


	let email
	let password
	let currentUser = false

	onMount(() => {
		checkAuthenticated()
	})

	let stage = 1

	// const submitResponse = () => {
	// 	if (responses.length == totalQuestions) {
	// 		console.log(responses)
	// 		db.collection("responses").doc(currentUser.uid + '_' + URLparams.get('id')).set({
	// 			form: URLparams.get('id'),
	// 			responses: responses,
	// 			timeSubmitted: Date.now(),
	// 			user: currentUser.uid
	// 		}).then(() => {
	// 			stage = 3
	// 		})
	// 	} else {
	// 		alert('Please answer all questions before submitting')
	// 	}
	// }
	const signIn = () => {
		auth.signInWithEmailAndPassword(email, password)
		.then()
		.catch((error) => {
			console.log(error)
		})
	}
	// const signIn = () => {
		
	// }
	const signOut = () => {
		auth.signOut()
	}
	const checkAuthenticated = () => {
		console.log('check auth')
		auth.onAuthStateChanged(function(user) {
			console.log('auth state changed')
			if (user) {
				currentUser = user
				console.log(user)
				currentUserStore.set(currentUser)
			} else {
				// No user is signed in.
			}
		})
	}
	const handleKeydown = event => {
		if (event.key == 'Enter' && !currentUser) {
			signIn()
		}
	}

</script>

<svelte:window on:keydown={handleKeydown}/>

<main>
	<!-- User is not authenticated, show login -->
	{#if currentUser == false}
		<Header title="Sign in to view"/>
		<div class="content">
			<h1>Enter your details</h1>
			<input type="email" placeholder="email" bind:value={email}>
			<input type="password" placeholder="password" bind:value={password}>
			<p class="label">You cannot edit your response afterwards, it just wont submit at the end. Please answer all questions.</p>
		</div>
		<div class="buttons">
			<button class="cta" on:click={signIn}>Sign In</button>
		</div>
	<!-- User is authenticated, show page -->
	{:else}
		<Router routes={{
			// Homepage
			'/': Homepage,
			// Edit/Create Form
			'/:form/edit': EditForm,
			// View Form Results
			'/:form/results': ViewFormResults,
			'/:form/present': PresentResults,
			// Answer Form
			'/:form': AnswerForm
		}}/>
	{/if}

	{#if stage == 3}
		<!-- <div class="content" in:fly="{{ y: -20, duration: 500 }}">
			<h1>Your response has been submitted.</h1>
			<p class="label">{submittedMessage}</p>
		</div> -->
	{/if}
	<!-- <p class="sign-out-button label" on:click={signOut}>Sign Out</p> -->
	<!-- <p class="version label">OKS Vote v1.1</p> -->
</main>

<style>
	:global(body) {
		--background-primary: #0B0C10;
		--background-secondary: #0F1014;
		--background-tertiary: #151619;
		--content-primary: #FFFFFF;
		--content-secondary: rgba(255,255,255,0.16);
		--accent-primary: #4020C7;
		--accent-secondary: #351D98;
		--title-font: 'Hind Madurai', 'Noto Sans', -apple-system, sans-serif;
		--body-font: 'Hind Madurai', 'Source Sans Pro', -apple-system, sans-serif;
		background: var(--background-primary);
		color: var(--content-primary);
		font-family: var(--body-font);
	}
	:global(h1) {
		font-size: 3em;
		font-weight: 600;
		line-height: 1.2em;
		margin: 0;
		font-family: var(--title-font);
	}
	:global(.label) {
		color: var(--content-secondary);
	}
	:global(p) {
		font-size: 1em;
		font-weight: 500;
		line-height: 1.6em;
		color: var(--content-primary);
	}
	:global(button) {
		padding: 16px 40px;
		width: max-content;
		border-radius: 6px;
		cursor: pointer;
		font-weight: 500;
		font-size: 1em;
		transition: 0.2s;
		float: left;
		border: none;
		color: var(--content-primary);
		background: var(--background-secondary);
		display: block;
		float: none;
	}
	:global(button.cta) {
		background: var(--accent-primary);	
	}
	:global(button.ghost) {
		background: none;
		color: var(--content-secondary);
	}
	:global(button.cta:hover) {
		background: var(--accent-secondary);
	}
	:global(input[type="text"], input[type="password"], input[type="email"], select, span.input) {
		appearance: none;
		-webkit-appearance: none;
		background: var(--background-secondary);
		border: 1px solid var(--background-tertiary);
		border-radius: 6px;
		padding: 16px 24px;
		color: var(--content-primary);
		margin-top: 2em;
		transition: 0.2s;
	}
	:global(textarea) {
		background: var(--background-secondary);
		border: 1px solid var(--background-tertiary);
		border-radius: 6px;
		outline: none;
		padding: 16px 24px;
		color: var(--content-primary);
		width: 100%;
		/* margin-top: 2em; */
		transition: 0.2s;
		resize: none;
	}
	/* :global(input[type="text"]:focus, input[type="password"]:focus, input[type="email"]:focus) {
		background: var(--background-tertiary);
	} */
	:global(select) {
		background-image: url('/assets/dropdown.svg');
		background-size: 10px;
		background-position: 90% center;
		background-repeat: no-repeat;
		padding-right: 20px;
		min-width: 250px;
	}
	
	input[type="password"] {
		margin-top: 4px;
	}
	:global(input[type="radio"], input[type="checkbox"]) {
		margin-right: 1em;
		background: none;
		border: 2px solid var(--background-tertiary);
		appearance: none;
		-webkit-appearance: none;
		border-radius: 50%;
		height: 24px;
		width: 24px;
		margin-bottom: 0;
		display: flex;
		float: left;
		transition: 0.2s;
		transition-property: border;
	}
	:global(input:focus) {
		outline: none;
	}
	:global(input[type="radio"]:hover, input[type="checkbox"]:hover) {
		border-color: var(--content-secondary);
	}
	:global(input[type="radio"]:checked) {
		background: url('/assets/radio-button-check.svg');
		background-size: 10px;
		background-position: center;
		background-repeat: no-repeat;
	}
	:global(input[type="checkbox"]) {
		border-radius: 6px;
	}
	:global(input[type="checkbox"]:checked, input[type="checkbox"].checked) {
		background: url('/assets/checkbox-check.svg');
		background-size: 10px;
		background-position: center;
		background-repeat: no-repeat;
	}
	:global(input[type="range"]) {
		appearance: none;
		-webkit-appearance: none;
		background: var(--background-tertiary);
		border: none;
		border-radius: 3px;
		height: 6px;
		min-width: 200px;
		width: 30%;
		padding: 0;
	}
	:global(input[type="range"]::-webkit-slider-thumb) {
		appearance: none;
		-webkit-appearance: none;
		background: var(--accent-primary);
		height: 20px;
		width: 20px;
		border-radius: 50%;
	}
	/* label input[type="radio"] ~ .checkmark {
		background: none;
		height: 10px;
		width: 10px;
		position: absolute;
	}
	label input:checked ~ .checkmark {
		background: var(--content-primary);
	} */
	:global(label) {
		font-weight: 500;
		margin-bottom: clamp(17px, 3vh, 30px);
		cursor: pointer;
	}
	.sign-out-button {
		position: absolute;
		top: 0;
		right: 0;
		margin: 50px 5%;
	}
	.version {
		position: absolute;
		bottom: 0;
		right: 0;
		margin: 60px 7%;
	}

	/* Universal Page Layout Styling */
	/* main {
		display: grid;
		grid-template: 100vh 145px / 100%;
		height: 100%;
	} */
	/* :global(.content) {
		grid-row: 1;
		grid-column: 1;
		align-self: center;
		margin: 4em 7% 4em;
	} */
	:global(.buttons) {
		grid-row: 1;
		grid-column: 1;
		align-self: end;
		margin: 0 0 10vh 7%;
	}

@media only screen and (max-width: 600px) {
	/* main {
		grid-template-rows: 1fr 100px;
	} */
	:global(body) {
		background: black;
	}
	:global(h1) {
		font-size: 42px;
		line-height: 50px;
	}
	:global(.content) {
		margin: 32px 5%;
		align-self: start;
	}
	:global(.buttons) {
		justify-self: center;
		margin: 0 0 80px 0 !important;
	}
	:global(label) {
		margin-bottom: 26px;
	}
	:global(input[type="text"], input[type="password"], input[type="email"], input[type="range"]) {
		width: 100% !important;
	}
	:global(.header) {
		display: none;
	}
}

	/* Main Text Styles */
	:global(h2, .h2) {
		font-size: 22px;
		color: var(--content-primary);
		font-weight: bold;
		font-family: var(--title-font);
		margin: 0;
		padding: 0;
	}

	/* Input Styles */
	:global(input.seamless, textarea.seamless ,select.seamless) {
		border: none;
		padding: unset;
		margin: unset;
		background: transparent;
		width: 100%;
	}

	/* Reoccuring Elements */
	:global(p.question-label) {
		margin: 0 0 15px 0;
		background: rgba(255, 255, 255, 0.08);
		padding: 6px 11px;
		font-family: var(--title-font);
		width: fit-content;
		font-size: 12px;
		border-radius: 6px;
		color: #666;
	}
	:global(p.question-label span) {
		color: white;
	}

	/* Common Layout */
	:global(.page) {
		display: grid;
		grid-template: 1fr / 280px 1fr;
		height: 100%;
	}
	:global(.content) {
		grid-row: 1;
		grid-column: 2;
		align-self: start;
	}
	:global(.sidebar) {
		background: var(--background-secondary);
		padding: 44px 28px;
		box-sizing: border-box;
		position: sticky;
		top: 0;
		min-height: 100vh;
		height: fit-content;
	}
	:global(.title-bar) {
		display: grid;
		grid-template: 70px / 1fr;
		align-items: center;
		padding: 0 7%;
		border-bottom: 1px solid var(--background-tertiary);
		/* background: var(--background-primary); */
		position: sticky;
		top: 0;
		backdrop-filter: blur(10px);
		-webkit-backdrop-filter: blur(10px);
	}
	:global(.title-bar .label-button) {
		grid-row: 1;
		grid-column: 1;
		justify-self: left;
		color: var(--content-secondary);
		cursor: pointer;
	}
	:global(.title-bar p.title) {
		grid-row: 1;
		grid-column: 1;
		justify-self: center;
	}
	:global(.title-bar .save-button) {
		grid-row: 1;
		grid-column: 1;
		justify-self: right;
		cursor: pointer;
	}

	/* :global(.question) {
		display: grid;
		grid-template: 60px 1fr / 45px 1fr;
		margin: 50px 7%;
	}
	:global(.question .question-label) {
		grid-row: 1;
		grid-column: 1;
		align-self: start;
	}
	:global(.question .h2, .question h2) {
		grid-row: 1;
		grid-column: 2;
		align-self: start;
	}
	:global(.question .question-type) {
		grid-row: 1;
		grid-column: 2;
		align-self: end;
		margin: 0;
	}
	:global(.question span, .question .question-responses) {
		grid-row: 2;
		grid-column: 2;
	}
	:global(.question .max-selections-input) {
		grid-column: 2;
		grid-row: 3;
	} */
</style>